import React, { useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PageHeader from "components/ui/PageHeader";
import cashierRoutes from "cashierRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const CashierLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((p, k) =>
      p.layout === "/cashier" ? <Route path={p.path} element={p.component} key={k} /> : null
    );

  const sidebarRoutes = useMemo(
    () => cashierRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const isFullPage = useMemo(
    () =>
      cashierRoutes.some(
        (r) => r.fullPage && location.pathname === `${r.layout}${r.path}`
      ),
    [location.pathname]
  );

  const brandText = useMemo(() => {
    for (let r of cashierRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "Cashier";
  }, [location.pathname]);

  const branchName = user?.branch?.name || "Branch";
  const userName = user?.firstName || (user?.username ? user.username.split("@")[0] : "");

  if (isFullPage) {
    return (
      <Routes>
        {getRoutes(cashierRoutes)}
        <Route path="*" element={<Navigate to="/cashier/dashboard" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/cashier/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/cashier/Profile" />
        <PageHeader
          role="cashier"
          eyebrow={`${branchName} · Cashier`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(cashierRoutes)}
            <Route path="*" element={<Navigate to="/cashier/dashboard" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default CashierLayout;